import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center mb-4" }
const _hoisted_2 = {
  key: 1,
  class: "divide-y divide-accent"
}
const _hoisted_3 = { class: "flex-grow min-w-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-xs text-muted"
}
const _hoisted_5 = { class: "text-sm text-muted truncate" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 2,
  class: "text-muted text-sm"
}

interface InviteEntry {
  rkey: string
  uri: string
  cid: string
  slug: string
  repo: string
  isActive: boolean
  createdAt: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Invites - admin - Daniel Roe' })

const { data, refresh, status } = useAdminFetch<InviteEntry[]>('/api/admin/invites', { default: () => [] })

const showSkeleton = computed(() => status.value === 'pending' && !data.value.length)

async function remove (rkey: string, slug: string) {
  if (!confirm(`Delete invite "${slug}"?`)) return
  const previous = data.value
  data.value = data.value.filter(i => i.rkey !== rkey)
  try {
    await $fetch(`/api/admin/invites/${rkey}`, { method: 'DELETE' })
    refresh()
  }
  catch (error) {
    data.value = previous
    throw error
  }
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_AdminSkeletonRows = _resolveComponent("AdminSkeletonRows")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Invites" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_NuxtLink, {
          to: "/admin/invites/new",
          class: "ml-auto text-sm bg-primary text-background px-3 py-1 hover:bg-primary/90 transition-colors"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" New invite ", -1)
          ]))]),
          _: 1
        })
      ]),
      (_unref(showSkeleton))
        ? (_openBlock(), _createBlock(_component_AdminSkeletonRows, { key: 0 }))
        : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (invite) => {
              return (_openBlock(), _createElementBlock("li", {
                key: invite.rkey,
                class: "py-3 flex items-center gap-4"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_NuxtLink, {
                    to: `/admin/invites/${invite.rkey}`,
                    class: "block underline-offset-4 hover:underline truncate"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" /" + _toDisplayString(invite.slug) + " ", 1),
                      (!invite.isActive)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(inactive)"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_5, " → " + _toDisplayString(invite.repo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-sm text-muted hover:text-red-500 transition-colors",
                  onClick: ($event: any) => (remove(invite.rkey, invite.slug))
                }, " Delete ", 8, _hoisted_6)
              ]))
            }), 128))
          ])),
      (!_unref(showSkeleton) && !_unref(data)?.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " No invites yet. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})